module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1jbG9zZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgIDxwYXRoIGQ9Ik0yIDMwIEwzMCAyIE0zMCAzMCBMMiAyIiAvPgo8L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-close.svg
// module id = yYNb
// module chunks = 50